import { DateBox } from "devextreme-react";
import { RequiredRule } from "devextreme-react/form";
import React, { useRef } from "react";

export default function TwoDateBoxComponent(props) {
  const { firstDateBox, secondDateBox, setFormDataSource } = props;

  const firstDateBoxRef = useRef(null);

  const onFirstValueChanged = (e) => {
    setFormDataSource((prevState) => ({
      ...prevState,
      [firstDateBox.field]: e.value,
    }));
  };

  const onSecondValueChanged = (e) => {
    setFormDataSource((prevState) => ({
      ...prevState,
      [secondDateBox.field]: e.value,
    }));
  };

  return (
    <React.Fragment>
      <DateBox
        ref={firstDateBoxRef}
        placeholder={firstDateBox ? firstDateBox.placeholder : ``}
        style={{
          float: "left",
          width: "49%",
          marginRight: "3px",
        }}
        displayFormat="yyyy-MM-dd"
        dateSerializationFormat="yyyy-MM-dd"
        showClearButton={true}
        max={firstDateBox ? firstDateBox.max : null}
        value={firstDateBox ? firstDateBox.value : null}
        onValueChanged={onFirstValueChanged}
      ></DateBox>
      <DateBox
        placeholder={secondDateBox ? secondDateBox.placeholder : ``}
        style={{
          float: "left",
          width: "49%",
        }}
        displayFormat="yyyy-MM-dd"
        dateSerializationFormat="yyyy-MM-dd"
        showClearButton={true}
        min={
          firstDateBoxRef.current
            ? firstDateBoxRef.current.instance.option("value")
            : null
        }
        max={secondDateBox ? secondDateBox.max : null}
        value={secondDateBox ? secondDateBox.value : null}
        onValueChanged={onSecondValueChanged}
      ></DateBox>
    </React.Fragment>
  );
}
